import styled from "@emotion/styled";

export const Offset = styled.div({
  height: 'calc(100%)',
  paddingTop: 74,
  '@media (min-width: 640px)': {
    paddingTop: 76,
  },
});